import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private http: HttpClient) {
  }
  fetchStudentCertificate(){
    return this.http.get<any>("/edozzier/portal-student-certificate.php", );
  }
  downloadStudentCertificate(data:any){
    console.log(data);
    
    return this.http.post<any>("/edozzier/portal-download-student-cert.php", data);
  }
}
